import { ContentTemplate } from '../models/ContentTemplate';

export const generateLayoutFromTemplate = ({ anchor }: ContentTemplate, moduleIds: string[]) => {
    const { style, properties } = anchor;
    const newAnchor = { style, properties, moduleIds };
    return {
        anchor: newAnchor
    };
};
